import { useState, useEffect } from 'react';
import DeviationMediaService from '../DeviationMediaService';
export function useHeroImage(deviation, width, height) {
    const [hero, setHero] = useState({
        hero: deviation && DeviationMediaService.getSmallestThumb(deviation),
        loaded: false
    });
    useEffect(()=>{
        if (!deviation) {
            setHero({
                hero: undefined,
                loaded: true
            });
            return;
        }
        const bestFitImage = DeviationMediaService.getSmallestThumbThatFullyCovers(deviation, width, height, (t)=>t[t.length - 1], {
            allowFullview: true,
            allowPreview: true
        });
        if (bestFitImage) {
            const img = new Image();
            img.onload = ()=>setHero({
                    hero: bestFitImage,
                    loaded: true
                });
            img.src = bestFitImage.src;
        }
    }, [
        deviation,
        height,
        width
    ]);
    return hero;
}
